module.exports = __webpack_public_path__ + "img/home_icon_jianzhu_sel.0ed0d2ae.png";